export default __webpack_public_path__ + "static/media/hottest-politics-logo.d456063d.svg";